import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp from 'components/StyledComp';
import DataTables from 'components-desktop/DataTables';
import helpers from 'misc/helpers';

const propTypes = {
  title: PropTypes.string,
  payments: PropTypes.array,
};

const defaultProps = {
  title: '',
  payments: [],
};

@autobind
class TablePayments extends BaseComponent {
  constructor(props) {
    super(props);
  }

  createColumns() {
    return [{
      title: 'Id',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
    }, {
      title: 'Check Number',
      dataIndex: 'checkNumber',
      sorter: (a, b) => a.checkNumber?.localeCompare(b.checkNumber),
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={`/payments/payment_details?id=${record.id}`}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'Company',
      dataIndex: 'companyName',
      sorter: (a, b) => a.companyName?.localeCompare(b.companyName),
    }, {
      title: 'Payment Method',
      dataIndex: 'paymentMethod',
      sorter: (a, b) => a.paymentMethod?.localeCompare(b.paymentMethod),
    }, {
      title: 'Check Date',
      dataIndex: 'checkDateUsString',
      sorter: (a, b) => a.checkDate - b.checkDate,
      defaultSortOrder: 'ascend',
    }, {
      title: 'Received Date',
      dataIndex: 'receivedDateUsString',
      sorter: (a, b) => a.receivedDate - b.receivedDate,
    }, {
      title: 'Total Amount',
      dataIndex: 'amountInDollars',
      sorter: (a, b) => a.amount - b.amount,
    }, {
      title: 'Remark',
      dataIndex: 'remark',
      sorter: (a, b) => a.remark?.localeCompare(b.remark),
      render: (text, record) => (
        <Tooltip title={text}>
          <styledComp.Span
            width="wrap_content"
            height="wrap_content"
            maxWidth="150px"
            color="textPrimaryDark"
            fontSize="12px"
            ellipsis
            display="inline-block"
          >
            {text}
          </styledComp.Span>
        </Tooltip>
      ),
    }];
  }

  createDataSource(payments) {
    const dataSource = [];
    payments.forEach((payment, index) => {
      dataSource.push({
        key: payment.getId(),
        id: payment.getId(),
        checkNumber: payment.getString('checkNumber'),
        companyId: payment.getLong('companyId'),
        companyName: payment.getString('companyName'),
        paymentMethod: payment.getString('paymentMethod'),
        checkDate: payment.getLong('checkDate'),
        checkDateUsString: payment.getString('checkDateUsString'),
        receivedDate: payment.getLong('receivedDate'),
        receivedDateUsString: payment.getString('receivedDateUsString'),
        amount: payment.getDouble('amount'),
        amountInDollars: helpers.toDollars(payment.getDouble('amount')),
        remark: payment.getString('remark'),
      });
    });
    return dataSource;
  }

  renderContent() {
    const { payments, title, ...layoutProps } = this.props;

    return (
      <DataTables
        {...layoutProps}
        ref={(ref) => { this.dataTables = ref; }}
        color="yellow_gold"
        fontSize="12px"
        size="small"
        title={title}
        icon="money-collect"
        columns={this.createColumns()}
        dataSource={this.createDataSource(payments)}
      />
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
TablePayments.propTypes = propTypes;
TablePayments.defaultProps = defaultProps;

export default TablePayments;
